import { useMemo } from 'react';
import { useTheme } from 'styled-components';
import complete from 'app/assets/concept-figures/complete.svg';
import custom from 'app/assets/concept-figures/custom.svg';
import engine from 'app/assets/concept-figures/engine.svg';
import foundational from 'app/assets/concept-figures/foundational.svg';
import hx8 from 'app/assets/concept-figures/hx8.svg';
import power from 'app/assets/concept-figures/power.svg';

export const useConceptBackground = (concept?: { name?: string } | null) => {
  const theme = useTheme();

  return useMemo(() => {
    const name = (concept?.name || '').toLowerCase();

    const patterns: Record<string, string> = {
      foundational,
      power,
      complete,
      engine,
      hx8,
    };

    const entry = Object.entries(patterns).find(([key]) => name.includes(key));
    const imageUrl = entry ? entry[1] : custom;

    const gradient = `linear-gradient(90deg, ${theme.colors.gold} 0%, ${theme.colors.faqGrey} 80%)`;

    return {
      gradient,
      imageUrl,
    };
  }, [concept?.name, theme.colors.gold, theme.colors.faqGrey]);
};
